const carouselItems = [
  {
    title: '暑期档热门',
    subtitle: '2026年夏季必看影视推荐',
    desc: '从最新院线大片到高分经典回顾，涵盖动作、喜剧、悬疑、动画等全类型，暑期追剧观影指南一网打尽。',
    tag: '编辑精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20theme%20with%20warm%20golden%20sunlight%2C%20movie%20watching%20atmosphere%2C%20dark%20theater%20ambiance%20with%20coral%20and%20amber%20accent%20lights%2C%20professional%20film%20photography%2C%20rich%20warm%20color%20palette%2C%20dramatic%20composition&width=900&height=500&seq=carousel-summer&orientation=landscape',
  },
  {
    title: '悬疑剧场',
    subtitle: '烧脑高能 · 全程无尿点',
    desc: '精选国内外高分悬疑剧集，错综复杂的案件、出人意料的反转，挑战你的推理能力。',
    tag: '专题合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20scene%20with%20dramatic%20shadow%20play%2C%20film%20noir%20aesthetic%2C%20suspenseful%20atmosphere%2C%20warm%20amber%20lighting%20through%20blinds%2C%20professional%20thriller%20photography%2C%20rich%20contrast%20and%20deep%20blacks&width=900&height=500&seq=carousel-mystery&orientation=landscape',
  },
  {
    title: '经典重温',
    subtitle: '光影永恒 · 不朽佳作',
    desc: '那些年我们追过的经典影视，从黑泽明到王家卫，从《教父》到《肖申克的救赎》，每一部都值得反复品味。',
    tag: '影史珍藏',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20old%20movie%20camera%20and%20film%20reels%2C%20warm%20sepia%20and%20golden%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20Hollywood%20golden%20age%20vibe%2C%20rich%20textured%20background%2C%20dramatic%20lighting&width=900&height=500&seq=carousel-classics&orientation=landscape',
  },
  {
    title: '国风动漫',
    subtitle: '东方美学 · 视觉盛宴',
    desc: '近年来国产动画佳作频出，从唯美古风到热血奇幻，展现独特的东方叙事美学和视觉风格。',
    tag: '动画推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eastern%20aesthetic%20animated%20scene%20with%20flowing%20ink%20and%20watercolor%20style%2C%20traditional%20Chinese%20artistic%20elements%2C%20warm%20golden%20and%20coral%20tones%2C%20fantasy%20landscape%2C%20cinematic%20composition%2C%20rich%20atmospheric%20depth&width=900&height=500&seq=carousel-anime&orientation=landscape',
  },
  {
    title: '纪录片精选',
    subtitle: '真实世界 · 震撼呈现',
    desc: '从自然奇观到人文历史，从科技前沿到社会纪实，每一部纪录片都是对真实世界的深度探索。',
    tag: '纪实佳作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20nature%20landscape%20with%20dramatic%20mountain%20range%20and%20golden%20light%2C%20cinematic%20documentary%20photography%2C%20warm%20sunset%20colors%2C%20professional%20composition%2C%20rich%20earthy%20tones%2C%20breathtaking%20vista&width=900&height=500&seq=carousel-documentary&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            精选专题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            精选专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            编辑精心策划的影视专题合集，发现更多值得观看的优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-400 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm font-medium text-foreground-600 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}